import * as actions from "./actionsTypes";

const initialData = {
  loading: false,
  loadingById: false,
  saveLoading: false,
  objectiveValuePillarsLength: 0,
  objectiveValuePillars: [],
  objectiveValuePillar: {},
  objectiveValuePillarError: "",
  formError: "",
};

export default function ObjectiveValuePillarReducer(state = initialData,action) {
  switch (action.type) {
    case actions.LOADING_OBJECTIVE_VALUE_PILLAR:
      return { ...state, loading: action.payload };
    case actions.LOADING_OBJECTIVE_VALUE_PILLAR_BY_ID:
      return { ...state, loadingById: action.payload };
    case actions.SAVE_LOADING_OBJECTIVE_VALUE_PILLAR:
      return { ...state, saveLoading: action.payload };
    case actions.GET_OBJECTIVE_VALUE_PILLAR:
      return {
        ...state,
        objectiveValuePillars: action.payload.objectiveValuePillars,
        objectiveValuePillarsLength: action.payload.objectiveValuePillarsLength,
      };
    case actions.GET_OBJECTIVE_VALUE_PILLAR_BY_ID:
      return {
        ...state, objectiveValuePillar: action.payload
      };
    case actions.FORM_FAIL:
      return { ...state, formError: action.payload };
    case actions.OBJECTIVE_VALUE_PILLAR_FAIL:
      return { ...state, objectiveValuePillarError: action.payload };
    default:
      return state;
  }
}
